import { SessionUserCredential } from "../../model";
import { Ajax, CrudApiBase } from "../infra";

/**
 * Provides CRUD access for authenticated user to access all credentials which can access this account.
 */
export class Credentials extends CrudApiBase<SessionUserCredential, never> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03/api/accounts/credential";

  constructor(ajax: Ajax) {
    super(ajax);
  }

  /**
   * Returns an empty credential without any values.
   */
  public getBlank(): SessionUserCredential {
    return {};
  }

  /**
   * Returns the url where to post the avatar file
   */
  public getAvatarUploadUrl(credentialId: string): string {

    return this.ajax.getServerAddress()
    +  this.baseUrl
    + (credentialId ? `/${credentialId}` : "" )
    + "/avatar";
  }

  /**
   * Gets all credentials from the API.
   * @returns A Promise that resolves to an array of SessionUserCredential objects.
   */
  public getAll(): Promise<SessionUserCredential[]> {
    return this.ajax.getJSON(this.baseUrl);
  }

  /**
   * OData query is not supported for credentials.
   * @param _query OData query parameters (not used)
   * @throws Error indicating operation is not supported
   */
  public getOData(_query: any): any {
    throw new Error("Not supported.");
  }

  /**
   * Getting a single credential is not supported.
   * @param _id Identifier of the credential (not used)
   * @throws Error indicating operation is not supported
   */
  public getSingle(_id: any): any {
    throw new Error("Not supported.");
  }

}
